import React from "react";
import { PageLoading } from "components/PageLoading";
import { LoginForm } from "components/LoginForm";

export const AuthContext = React.createContext();
AuthContext.displayName = "AuthContext";

export function AuthProvider(props) {
  const [authState, authDispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "loggedIn":
          return { ...s, user: action.user, isProcessing: false };
        case "noUser":
          return { ...s, user: null, isProcessing: false };
        default:
          return s;
      }
    },
    { user: null, isProcessing: true }
  );
  React.useEffect(() => {
    window.firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        authDispatch({ type: "loggedIn", user });
      } else {
        authDispatch({ type: "noUser" });
      }
    });
  }, []);

  if (authState.isProcessing) {
    return <PageLoading />;
  } else if (!authState.user) {
    return <Login></Login>;
  } else {
    const value = { user: authState.user, logout };
    return <AuthContext.Provider value={value} {...props} />;
  }
}

function Login() {
  const login = ({ email, password }) => {
    window.firebase.auth().signInWithEmailAndPassword(email, password);
  };

  return <LoginForm onSubmit={login}></LoginForm>;
}

function logout() {
  window.firebase.auth().signOut();
}
